import { useQuery } from '@apollo/client';

import useConfig from 'app/config';
import LEADS_ACCESS from 'app/features/leads/graphql/leads-access.gql';
import { type LeadsAccessQuery, type LeadsAccessQueryVariables, UserRole } from 'app/types/graphql';
import { useAppState } from 'state';

const LEADS_ACCESS_ROLES = new Set<UserRole>([UserRole.BUSINESS_OWNER, UserRole.GYM_MANAGER, UserRole.GYM_OWNER]);

export const useLeadsAccess = () => {
  const { config } = useConfig();
  const enabled = config.REACT_APP_GYM_FINDER_LEADS_ENABLED;
  const userId = useAppState(({ auth }) => auth.userId);
  const hasUser = userId != null;

  const { data, loading } = useQuery<LeadsAccessQuery, LeadsAccessQueryVariables>(LEADS_ACCESS, {
    variables: hasUser ? { id: userId } : undefined,
    skip: !enabled || !hasUser,
    fetchPolicy: 'cache-first',
  });

  const userRole = data?.userById?.userRole;
  const hasLeadsRole = userRole != null && LEADS_ACCESS_ROLES.has(userRole);

  return {
    canAccessLeads: enabled && hasLeadsRole,
    isLoading: enabled && hasUser && loading,
  };
};
